module.exports = __webpack_public_path__ + "img/course.4d47460b.png";